export interface BidHumanChoiceEnum<T = string> {
  value: T;
  label: string;
}
export interface BidMonetaryObjectField<T = number> {
  value: T;
  label: string;
}

export type UserExtraPermissions =
  | "reseller.view_child_resellers_operation"
  | "loan.view_dashboard_report";

export function isUserExtraPermissions(
  data: unknown,
): data is UserExtraPermissions {
  return (
    data === "reseller.view_child_resellers_operation" ||
    data === "loan.view_dashboard_report"
  );
}

export type ValidationError = {
  [key: string]: string[] | { [key: string]: string[] };
};

export function isValidationError(data: unknown): data is ValidationError {
  // Validate if the payload of an HTTP respose is a Django REST Framework ValidationError
  return (
    // It must be an object
    typeof data === "object" &&
    // It must not be null
    data !== null &&
    Object.values(data).every(
      (value) =>
        // If the value of the key is an array, it must be an array of strings
        (Array.isArray(value) &&
          value.every((item) => typeof item === "string")) ||
        // Else, it must be an object (there are nested validation errors)
        typeof value === "object",
    )
  );
}

export interface BidLoanException {
  service: "fgts_loan";
  exception_code: string;
  exception_message: string;
  exception_details: null | { [key: string]: string[] };
}

export function isBidLoanException(data: unknown): data is BidLoanException {
  return (
    typeof data === "object" &&
    data !== null &&
    "service" in data &&
    data["service"] === "fgts_loan" &&
    "exception_code" in data &&
    typeof data["exception_code"] === "string" &&
    "exception_message" in data &&
    typeof data["exception_message"] === "string" &&
    "exception_details" in data &&
    (data["exception_details"] === null || typeof data === "object")
  );
}

export interface CreateProposalError {
  type: string;
  src: string;
  enumerator: string;
  message: {
    operator: string;
    borrower: string;
  };
  data: Record<string, unknown>;
}

export function isCreateProposalError(
  data: unknown,
): data is CreateProposalError {
  return (
    typeof data === "object" &&
    data !== null &&
    "type" in data &&
    typeof data["type"] === "string" &&
    "src" in data &&
    typeof data["src"] === "string" &&
    "enumerator" in data &&
    typeof data["enumerator"] === "string" &&
    "message" in data &&
    typeof data["message"] === "object" &&
    data["message"] !== null &&
    "operator" in data["message"] &&
    typeof data["message"]["operator"] === "string"
  );
}

export type FgtsBankingBackend = "BMP" | "QI_TECH" | "ZIPDIN";
export type FgtsBankingBackendWithAll = FgtsBankingBackend | "__all__";
export type CltBankingBackend = "CELCOIN" | "CREFAZ";
export type CltBankingBackendWithAll = CltBankingBackend | "__all__";

export type BidBankingBackend = FgtsBankingBackend | CltBankingBackend;
export type BidBankingBackendWithAll = BidBankingBackend | "__all__";

export interface BidApiPaginationSchema<T> {
  previous: string;
  next: string;
  count: number;
  results: T[];
}

export type UUID = string;
export type ISO8601 = string;
export type Decimal = string;

export interface LookupModelDict {
  code: string;
  description?: string;
}
